import { Dictionary } from 'lodash';
import { GlobalNotification } from '../../models/';
import { APPLICATION_DISCONNECTED } from '../constants.index';
import ReducerCreator from '../registerReducer';
import { StoreItem } from '../Store';
import { copyStoreItem } from '../storeItemBuilder';
import { GLOBALNOTIFICATION_UPDATE } from './globalNotifications.constants';

const defaultState = new StoreItem<GlobalNotification>();
defaultState.isLoaded = true;

const r = new ReducerCreator<GlobalNotification>()
    .register<Dictionary<GlobalNotification>>(GLOBALNOTIFICATION_UPDATE, (state, payload) => {
        return copyStoreItem(payload);
    })
    .register<GlobalNotification[]>(APPLICATION_DISCONNECTED, (state, payload) => {
        const newState = new StoreItem<GlobalNotification>();
        newState.isLoaded = true;
        return newState;
    });

export function globalNotificationsReducer(state: StoreItem<GlobalNotification> = defaultState, action: { type: string; payload: any }) {
    return r.reduce(state, action);
}